import { Flex, Text } from "@fluentui/react-northstar";
import React, { useMemo } from "react";

import { usePaymentRedirect } from "../../actions/usePaymentRedirect";
import { useUserInfo } from "../../actions/useUserInfo";
import AgileLogo from "../../assets/agile-polly-logo-only.svg";
import CoreLogo from "../../assets/polly-logo-no-text.svg";
import { getPlanLabel } from "../../types/subscriptionHelper";
import { startCheckoutTask } from "../../utils/startTaskWrapper";
import { getPageContext } from "../../utils/teamsHelpers";
import { getTrialDaysLeftText, isStaleTrialSub } from "../../utils/userHelpers";
import useWindowDimensions from "../../utils/useWindowDimensions";
import { PollyIcon } from "../PollyIcon";

type Props = { isMobile: boolean };
export const SubscriptionStateDisplay: React.FC<Props> = ({ isMobile }) => {
  const { user, loadUser } = useUserInfo();
  const { openPaymentPage } = usePaymentRedirect();
  const { width } = useWindowDimensions();

  let body: React.ReactNode = null;

  const subscription =
    user.subscriptions.find(sub => sub.state === "active") ??
    user.adminSubscriptions.find(sub => sub.state === "active");

  const iconImage = useMemo(() => {
    const app = getPageContext();

    return app === "/agile" ? AgileLogo : CoreLogo;
  }, []);

  if (!subscription || isStaleTrialSub(subscription, user.featureFlags)) {
    body = "Upgrade";
  }

  if (subscription?.type === "trial") {
    if (subscription.state === "active") {
      body = (
        <>
          <PollyIcon
            icon="trial-icon"
            primary
            ignoreTheme
            label={`Trial: ${getTrialDaysLeftText(subscription, user.featureFlags)}`}
            labelPlacement="after"
          />
          {}
        </>
      );
    } else if (!isStaleTrialSub(subscription, user.featureFlags)) {
      body = "⚠️ Trial has ended!";
    }
  }

  if (subscription?.type === "full") {
    if (subscription.state === "active") {
      body = `${getPlanLabel(
        subscription.plan,
        subscription.planLevel,
        subscription.scope
      )} Subscription`;
      if (subscription.isAdmin && !subscription.isOwner) {
        body += " (Admin Only)";
      }
    } else {
      body = "⚠️ Subscription ended!";
    }
  }

  return (
    <Flex
      gap="gap.small"
      vAlign="center"
      className="usermenu__popup_subscription_state"
      key={subscription?.id || "subscription"}
    >
      <img src={iconImage} height={30} alt="Polly" />
      {!isMobile && (
        <Flex column>
          <Text content={getPageContext() === "/agile" ? "AgilePolly" : "Polly"} weight="bold" />
          {(!subscription || subscription.state !== "active" || subscription.type === "trial") && (
            <a
              href="#payment"
              onClick={() => {
                if (getPageContext() === "/agile") {
                  openPaymentPage("navbar-icon");
                } else {
                  startCheckoutTask(false, "navbar-icon", width, () => {
                    loadUser(true);
                  });
                }
              }}
              style={{ textDecoration: "none", color: "var(--polly-accent-color)" }}
            >
              <Text content={body} />
            </a>
          )}
          {subscription && subscription.state === "active" && subscription.type === "full" && (
            <Text
              content={body}
              weight="light"
              onClick={() => {
                if (subscription && subscription.state === "active") {
                  return;
                }
              }}
            />
          )}
        </Flex>
      )}
    </Flex>
  );
};
